import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { general } from 'src/app/models/general';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-solicitud-simulador',
  templateUrl: './solicitud-simulador.component.html',
  styleUrls: ['./solicitud-simulador.component.css']
})
export class SolicitudSimuladorComponent implements OnInit {

  public modelGeneral
  public bancos

  constructor( private dialogRef: MatDialogRef<SolicitudSimuladorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private user: UserService) {
      this.modelGeneral = new general();
      this.modelGeneral.codBanco = 0
      this.modelGeneral.tipCuenta = 0
      this.modelGeneral.tipoSol = 0
      this.modelGeneral.observaciones = ''
     }

  ngOnInit(): void {
    this.getBancos()
  }

  cerrar() {
    this.dialogRef.close({ data: false });
  }

  guardar(){
    this.dialogRef.close({ data: this.modelGeneral });
  }

  getBancos(){
    let data = {
      tabla: 'CAJABANCOS',
      item1: 'CODBANCO',
      item2: 'DESCRIPCION'
    }
    this.user.httpPost('selectDinamico', data).subscribe(resp => {
      this.bancos = resp;
    })
  }

}
